var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { faQuestion } from '@fortawesome/pro-solid-svg-icons/faQuestion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import CustomSelect from '../Forms/Fields/ReusableSelect';
import FontPicker from '../Forms/Fields/FontPicker';
import IconPopover from '../IconPopover';
import { ColorBox, FontPickerContainer, Input } from './styles';
import { Box, Button, Radio } from '../Forms/Fields';
import MediaInput from '../Forms/Fields/MediaInput';
import { capitalizeFirst, fontSizeRange, fontSpacingRange } from '../../utils';
import { IconContainer } from '../IconPopover/styles';
export var ImageSizeOptions = [
    'cover',
    'contain',
    'stretch',
    'repeat',
    'center',
].map(function (option) { return ({
    value: option,
    label: capitalizeFirst(option),
}); });
export var FontWeights = [
    { value: 'normal', label: 'Normal' },
    { value: 'bold', label: 'Bold' },
];
export var FontWeightsNumbered = [
    { value: 'normal', label: 'normal' },
    { value: 'bold', label: 'bold' },
    { value: '100', label: '100' },
    { value: '200', label: '200' },
    { value: '300', label: '300' },
    { value: '400', label: '400' },
    { value: '500', label: '500' },
    { value: '600', label: '600' },
    { value: '700', label: '700' },
    { value: '800', label: '800' },
    { value: '900', label: '900' },
];
export var FontFamilies = [
    { value: 'System', label: 'System' },
    { value: 'Josefin Sans', label: 'Josefin Sans' },
    { value: 'Lato', label: 'Lato' },
    { value: 'Merriweather', label: 'Merriweather' },
    { value: 'Montserrat', label: 'Montserrat' },
    { value: 'Noto Sans', label: 'Noto Sans' },
    { value: 'Noto Serif', label: 'Noto Serif' },
    { value: 'Open Sans', label: 'Open Sans' },
    { value: 'Open Sans Condensed', label: 'Open Sans Condensed' },
    { value: 'Oswald', label: 'Oswald' },
    { value: 'Overpass', label: 'Overpass' },
    { value: 'Playfair Display', label: 'Playfair Display' },
    { value: 'Poppins', label: 'Poppins' },
    { value: 'PT Sans', label: 'PT Sans' },
    { value: 'PT Serif', label: 'PT Serif' },
    { value: 'Raleway', label: 'Raleway' },
    { value: 'Roboto', label: 'Roboto' },
    { value: 'Roboto Condensed', label: 'Roboto Condensed' },
    { value: 'Roboto Slab', label: 'Roboto Slab' },
    { value: 'Slabo 27px', label: 'Slabo 27px' },
    { value: 'Ubuntu', label: 'Ubuntu' },
];
export var FontStyles = [
    { value: 'normal', label: 'Normal' },
    { value: 'italic', label: 'Italic' },
];
export var FontSizes = fontSizeRange(2, 50).map(function (option) { return ({
    value: option,
    label: option,
}); });
export var GlobalStylesFontSizes = fontSizeRange(0, 48).map(function (option) { return ({
    value: option,
    label: option,
}); });
export var FontSpacing = fontSpacingRange(0, 28).map(function (option) { return ({
    value: option,
    label: option,
}); });
export var TextDecorations = [
    { value: 'none', label: 'None' },
    { value: 'underline', label: 'Underline' },
    { value: 'line-through', label: 'Line through' },
    { value: 'underline line-through', label: 'Underline line through' },
];
export var TextTransforms = [
    { value: 'none', label: 'None' },
    { value: 'uppercase', label: 'Uppercase' },
    { value: 'lowercase', label: 'Lowercase' },
    { value: 'capitalize', label: 'Capitalize' },
];
export var TransitionOptions = [
    { value: 'none', label: 'None' },
    { value: 'fadeIn', label: 'Fade in' },
    { value: 'slideIn', label: 'Slide in' },
    { value: 'fromBottom', label: 'From bottom' },
    { value: 'zoomIn', label: 'Zoom in' },
    { value: 'rotate', label: 'Rotate' },
];
export var TransitionDurations = [
    {
        id: '500',
        label: 'Slow',
    },
    {
        id: '250',
        label: 'Medium',
    },
    {
        id: '100',
        label: 'Fast',
    },
];
export var BorderStyles = [
    { value: 'solid', label: 'Solid' },
    { value: 'dotted', label: 'Dotted' },
    { value: 'dashed', label: 'Dashed' },
];
export var EllipsizeModes = [
    { value: 'clip', label: 'Clip' },
    { value: 'head', label: 'Head' },
    { value: 'middle', label: 'Middle' },
    { value: 'tail', label: 'Tail' },
];
export var FlexDirections = [
    { value: 'row', label: 'Row' },
    { value: 'row-reverse', label: 'Row reverse' },
    { value: 'column', label: 'Column' },
    { value: 'column-reverse', label: 'Column reverse' },
];
export var JustifyContents = [
    { value: 'flex-start', label: 'Flex start' },
    { value: 'flex-end', label: 'flex end' },
    { value: 'center', label: 'Center' },
    { value: 'space-between', label: 'Space between' },
    { value: 'space-around', label: 'Space around' },
    { value: 'space-evenly', label: 'Space evenly' },
];
export var AlignItems = [
    { value: 'flex-start', label: 'Flex start' },
    { value: 'flex-end', label: 'Flex end' },
    { value: 'center', label: 'Center' },
    { value: 'stretch', label: 'Stretch' },
    { value: 'baseline', label: 'Baseline' },
];
export var Paddings = ['top', 'bottom', 'left', 'right'];
export var NumberInput = function (_a) {
    var field = _a.field, value = _a.value, onChange = _a.onChange;
    return (_jsx(Input, { value: value, type: "number", style: { textAlign: 'right' }, onChange: function (e) { return onChange(field, Math.abs(Number(e.target.value))); } }));
};
export var CheckboxInput = function (_a) {
    var field = _a.field, value = _a.value, onChange = _a.onChange;
    return (_jsx(Box, { type: "checkbox", checkbox: true, style: { marginTop: '5px' }, name: "".concat(field), onChange: function (e) { return onChange(field, e.target.checked); }, checked: value }));
};
export var RadioInput = function (_a) {
    var field = _a.field, value = _a.value, onChange = _a.onChange, options = _a.options;
    return (_jsx(Radio, { value: value, onChange: function (e) { return onChange(field, e.target.value); }, options: options }));
};
export var SelectInput = function (_a) {
    var field = _a.field, value = _a.value, onChange = _a.onChange, options = _a.options;
    return (_jsx(CustomSelect, { options: options, value: options.find(function (option) { return value === option.value; }), onChange: function (e) { return onChange(field, e.value); } }));
};
export var ColorInput = function (_a) {
    var width = _a.width, height = _a.height, isClearable = _a.isClearable, field = _a.field, value = _a.value, onChange = _a.onChange, swatches = _a.swatches;
    return (_jsx(ColorBox, { hex: true, bottom: true, style: { width: width, height: height, padding: 1 }, color: value || '', onChange: function (e) { return onChange(field, e.hex); }, swatches: swatches, isClearable: isClearable }));
};
export var ImagePickerInput = function (_a) {
    var field = _a.field, value = _a.value, onChange = _a.onChange;
    return (_jsxs(React.Fragment, { children: [_jsx(MediaInput, { onSelectFile: function (image) { return onChange(field, image.url); }, selectedFile: value, type: "image_icon" }), _jsx(Button, __assign({ small: true, onClick: function () { return onChange(field, ''); }, noMargin: true }, { children: "Clear" }))] }));
};
export var FontPickerInput = function (_a) {
    var field = _a.field, value = _a.value, fontWeight = _a.fontWeight, onChange = _a.onChange;
    return (_jsx(FontPickerContainer, { children: _jsx(FontPicker, { value: value, onChange: function (e) { return onChange(field, e.value); }, fontWeight: fontWeight }) }));
};
export var IconPickerInput = function (_a) {
    var field = _a.field, value = _a.value, customIcons = _a.customIcons, onChange = _a.onChange;
    return (_jsxs(React.Fragment, { children: [_jsx(IconPopover, { icon: value || faQuestion, color: "#000", onChange: function (e) { return onChange(field, e); }, customIcons: customIcons }), _jsx(IconContainer, { children: _jsx(FontAwesomeIcon, { style: { marginLeft: '10px' }, icon: faTimes, color: "#000", onClick: function () { return onChange(field, null); } }) })] }));
};
